import { render, staticRenderFns } from "./MachineSoftware.vue?vue&type=template&id=5f8bf0de&scoped=true"
import script from "./MachineSoftware.vue?vue&type=script&lang=js"
export * from "./MachineSoftware.vue?vue&type=script&lang=js"
import style0 from "./MachineSoftware.vue?vue&type=style&index=0&id=5f8bf0de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8bf0de",
  null
  
)

export default component.exports